import { useEffect, useState } from "react";
import api from "../lib/api";
import BranchPicker from "../components/BranchPicker";

const dt = (s) => (s ? new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short", timeZone: "Asia/Kolkata" }) : "—");

function Section({ title, items, render, tone = "red" }) {
  const tones = { red: "border-red-200 bg-red-50", amber: "border-amber-200 bg-amber-50" };
  return (
    <div className="mt-5">
      <h2 className="font-heading text-sm font-bold uppercase tracking-widest text-slate-500">{title} <span className="text-slate-300">· {items.length}</span></h2>
      <div className="mt-2 space-y-2">
        {items.length === 0 && <div className="rounded-xl border border-dashed border-slate-200 p-4 text-center text-xs text-slate-400">None</div>}
        {items.map((item, i) => <div key={i} className={`rounded-xl border p-3 text-xs ${tones[tone]}`}>{render(item)}</div>)}
      </div>
    </div>
  );
}

export default function Exceptions() {
  const [d, setD] = useState(null);
  const [branchId, setBranchId] = useState(null);
  useEffect(() => { api.get("/analytics/exceptions", { params: { branch_id: branchId || undefined } }).then((r) => setD(r.data)); }, [branchId]);
  if (!d) return <div className="p-8 text-slate-400">Loading…</div>;

  return (
    <div className="px-4 py-5 lg:px-8 max-w-3xl">
      <div className="flex items-center justify-between gap-3">
        <h1 className="font-heading text-2xl font-bold text-[#0E2240]">Exception Report</h1>
        <BranchPicker value={branchId} onChange={setBranchId} />
      </div>
      <p className="text-xs text-slate-500 mt-0.5">Daily digest · overdue trips, odometer mismatches, gate overrides, deviations, DL variations, workshop overdue</p>

      <Section title="Overdue trips" items={d.overdue_trips} render={(t) => (
        <><b className="text-[#0E2240]">{t.reg_no}</b> · {t.kec_name} · {t.customer_name} · gate pass expired {dt(t.validity)}, trip not closed</>)} />
      <Section title="Odometer mismatches (KEC vs Security beyond ±2 km)" items={d.odo_mismatches} render={(m) => (
        <><b className="text-[#0E2240]">{m.reg_no}</b> · {m.kec_name} · {m.date} · security out {m.out_odo ?? "—"} km / in {m.in_odo ?? "—"} km {m.mismatch_out && "· OUT mismatch"} {m.mismatch_in && "· IN mismatch"}</>)} />
      <Section title="Manual gate overrides" items={d.gate_overrides} tone="amber" render={(o) => (
        <><b className="text-[#0E2240]">{o.reg_no}</b> · {o.kec_name} · {o.date} · manual override by SM</>)} />
      <Section title="Home TD route deviations" items={d.deviations} tone="amber" render={(t) => (
        <><b className="text-[#0E2240]">{t.reg_no}</b> · {t.kec_name} · drove {t.km_driven ?? ((t.closing_km || 0) - t.opening_km)} km vs expected {t.expected_km} km</>)} />
      <Section title="Workshop overdue returns" items={d.workshop_overdue} render={(w) => (
        <><b className="text-[#0E2240]">{w.reg_no}</b> · RO {w.ro_number} · in since {w.handover_dt} · expected back {w.expected_return_date}</>)} />
      <Section title="Driving licence variations (gated in / closed without DL)" items={d.no_dl || []} render={(t) => (
        <><b className="text-[#0E2240]">{t.reg_no}</b> · {t.kec_name} → {t.customer_name} · {t.type} · {t.closed_without_dl ? `closed ${dt(t.closed_ts)} without DL for ${(t.dl_missing_customers || []).join(", ")}` : `gated in without DL ${dt(t.dl_missing_ts)}`}{t.dl_photo && t.dl_missing_flag && !t.closed_without_dl ? " · DL uploaded later" : ""}</>)} />
      <Section title="Force-closed by Admin" items={d.force_closed || []} tone="amber" render={(t) => (
        <><b className="text-[#0E2240]">{t.reg_no}</b> · {t.kec_name || "transfer"} · force-closed by {t.force_closed_by} {dt(t.closed_ts)}: “{t.force_close_reason}”</>)} />
      <Section title="Gate scans recorded by Admin" items={d.admin_gate_scans || []} tone="amber" render={(s) => (
        <><b className="text-[#0E2240]">{s.reg_no}</b> · {s.kec_name} · gate-{s.direction.toUpperCase()} {s.odometer} km recorded by {s.by} on behalf of <b>{s.acting_branch_name}</b> {dt(s.ts)}{s.at_expected_gate === false && <span className="ml-1 font-bold text-[#BB162B]">· not the expected gate</span>}</>)} />
    </div>
  );
}
